import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMarkNotificationsAsReadRequestFailure() {
      return getState().isFailure;
    },
    isMarkNotificationsAsReadRequestPending() {
      return getState().isPending;
    },
    isMarkNotificationsAsReadRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
